import { useWorkshopOccupancy } from '@features/workshop-plan/hooks/use-workshop-occupancy';

/** Keeps the real time stream of the workshop open on every page of it. Renders nothing. */
export const WorkshopRealtime = () => {
  useWorkshopOccupancy();

  return null;
};
